import { inject, Injectable } from '@angular/core';
import { DialogService } from '@miq/platform';
import { ConfirmDialogComponent } from '../dialogs/confirm-dialog/confirm-dialog.component';
import { L10nTranslationService } from 'angular-l10n';
/*
 * L2-R6: moved from `src/app/shared/services/deactivate-guard.service.ts`. It lands in
 * @miq/platform-ui rather than @miq/platform because it opens ConfirmDialogComponent, and the
 * dependency direction is platform-ui -> platform. The old host path is a re-export shim.
 *
 * The per-call builder flags (showCancelButton / swap / showCloseButton) are mutable instance
 * state on a `providedIn: 'root'` singleton, so a second bundled copy also meant two independent
 * builders; sharing one instance keeps the fluent setters coherent across both shells.
 */
@Injectable({
  providedIn: 'root',
})
export class DeactiveDialogService {
  private showCancelButton: boolean = true;
  private swap: boolean = true;
  private showCloseButton: boolean = true;
  private readonly notificationService = inject(DialogService);
  private readonly translationService = inject(L10nTranslationService);
  showDialog(message?: string, confirmText?: string, cancelText?: string, leaveMessage?: string) {
    let cancelTextToDisplay: string = undefined;
    if (this.showCancelButton) {
      cancelTextToDisplay = cancelText ? cancelText : this.translationService.translate('shared.leave');
    }
    const data = {
      message: message ? message : this.translationService.translate('shared.youHaveUnsavedChanges'),
      confirmText: confirmText ? confirmText : this.translationService.translate('shared.stay'),
      cancelText: cancelTextToDisplay,
      swap: this.swap,
      leaveMessage: leaveMessage ? leaveMessage : this.translationService.translate('shared.clickStayAndHitSave'),
      showCloseButton: this.showCloseButton,
    };
    return this.notificationService.openDialog(ConfirmDialogComponent, data, {}, false);
  }
  public setShowCancelButton(isShowCancelButton: boolean): DeactiveDialogService {
    this.showCancelButton = isShowCancelButton;
    return this;
  }
  public setSwap(isSwap: boolean): DeactiveDialogService {
    this.swap = isSwap;
    return this;
  }
  public setShowCloseButton(isShowCloseButton: boolean): DeactiveDialogService {
    this.showCloseButton = isShowCloseButton;
    return this;
  }
}
